// Membership Check tab (all users): is this phone / member ID registered?
import React from "react";
import { Alert, Button, Col, Form, Input, Row, Spinner, Table } from "reactstrap";
import { PageShell, StatusBadge } from "./memberComponents.jsx";
import { formatDate, formatPhone, memberPost } from "./memberApi.js";

class MembershipCheck extends React.Component {
  state = { keyword: '', loading: false, result: null };

  search = (e) => {
    e.preventDefault();
    if (!this.state.keyword.trim()) return;
    this.setState({ loading: true, result: null });
    memberPost('member-lookup', { keyword: this.state.keyword.trim() }).then(json => this.setState({ loading: false, result: json }));
  };

  render() {
    const r = this.state.result;
    return (
      <PageShell title="Membership Check">
        <Form onSubmit={this.search}>
          <Row className="align-items-center">
            <Col md="6" className="mb-2">
              <Input autoFocus placeholder="Key in phone number, member ID or IC" value={this.state.keyword} onChange={e => this.setState({ keyword: e.target.value })} />
            </Col>
            <Col md="2" className="mb-2">
              <Button color="primary" type="submit" disabled={this.state.loading}>{this.state.loading ? <Spinner size="sm" /> : 'Check'}</Button>
            </Col>
          </Row>
        </Form>

        {r && r.success == 1 ? (
          <div className="mt-3">
            <Alert color="success"><strong>Registered member</strong></Alert>
            <Table size="sm" style={{ maxWidth: 560 }}>
              <tbody>
                <tr><th>Member ID</th><td><strong>{r.member.memberid}</strong></td></tr>
                <tr><th>Branch</th><td>{r.member.server || 'Not assigned yet'}</td></tr>
                <tr><th>Name</th><td>{r.member.name}</td></tr>
                <tr><th>Phone</th><td>{formatPhone(r.member.phone)}</td></tr>
                <tr><th>IC</th><td>{r.member.icnumber}</td></tr>
                <tr><th>Email</th><td>{r.member.email}</td></tr>
                <tr><th>Status</th><td><StatusBadge status={r.member.status} /></td></tr>
                <tr><th>Registered</th><td>{formatDate(r.member.dateCreate)}</td></tr>
              </tbody>
            </Table>
          </div>
        ) : r && r.notfound ? (
          <Alert color="warning" className="mt-3">Not a member yet. Ask the customer to scan the membership QR code to register.</Alert>
        ) : r ? (
          <Alert color="danger" className="mt-3">{r.message}</Alert>
        ) : null}
      </PageShell>
    );
  }
}

export default MembershipCheck;
